export const CARD_TYPES = {
  PHYSICAL: "カード",
  ELECTRONIC: "モバイル",
}

export type CardType = (typeof CARD_TYPES)[keyof typeof CARD_TYPES]

export const CardTypeParam = new Map<CardType, string>([
  [CARD_TYPES.PHYSICAL, "physical"],
  [CARD_TYPES.ELECTRONIC, "electronic"],
])

export const getCardTypeFromParam = (param: string): CardType | undefined => {
  for (const [type, typeParam] of Array.from(CardTypeParam.entries())) {
    if (typeParam === param) {
      return type
    }
  }
}

export const CARD_STATUSES = {
  IN_USE: "利用中",
  SUSPENDED: "停止中",
}

export type CardStatus = (typeof CARD_STATUSES)[keyof typeof CARD_STATUSES]

export const CardStatusParam = new Map<CardStatus, string>([
  [CARD_STATUSES.IN_USE, "inuse"],
  [CARD_STATUSES.SUSPENDED, "suspended"],
])

export const getCardStatusFromParam = (
  param: string
): CardStatus | undefined => {
  for (const [status, statusParam] of Array.from(CardStatusParam.entries())) {
    if (statusParam === param) {
      return status
    }
  }
}

export type Card = {
  id: number
  number: string
  type: CardType
  status: CardStatus
  nickname: string
  membermail: string | null
  password: string | null
}

export type CardProperty = keyof Card

export const CARD_VALUE_MAX_LENGTH = {
  NICKNAME: 40,
}

// A type for MEMCARDMNG table of Daikoku's itc database.
export type DaikokuCard = {
  memcard_id: number
  memcard_no: string
  member_c: string
  servicegp_c: string
  memcard_id_nk: number | null
  memcard_zyokyo: MEMCARD_ZYOKYO
  pntzan: number
  siyozumipoint: number | null
  yukostartymd: Date | null
  yukoendymd: Date | null
  memcardsiyosya_nm: string
  memcardpwd: string | null
  biko: string | null
  pointupdymd: string | null
  memcd_st_upddt: Date
  pms_i_ymd: Date | null
  pms_i_usr: string
  pms_i_class: string | null
  pms_u_ymd: Date | null
  pms_u_usr: string | null
  pms_u_class: string | null
  felica_idm: string | null
  park_pnt_total: number | null
  cardType: string
  mailaddr: string | null
}

// 0：正常(使用中) 1：有効期間切れ 11：使用再開 12：使用停止 19：廃止
export const MEMCARD_ZYOKYOS = {
  IN_USE: "0",
  EXPIRED: "1",
  RESUMED: "11",
  SUSPENDED: "12",
  REMOVED: "19",
}

export type MEMCARD_ZYOKYO =
  (typeof MEMCARD_ZYOKYOS)[keyof typeof MEMCARD_ZYOKYOS]

export const convertDaikokuMemcardToCard = (daikokuCard: DaikokuCard): Card => {
  return {
    nickname: daikokuCard.memcardsiyosya_nm,
    id: daikokuCard.memcard_id,
    number: daikokuCard.memcard_no,
    membermail: daikokuCard.mailaddr,
    type:
      daikokuCard.mailaddr !== null
        ? CARD_TYPES.ELECTRONIC
        : CARD_TYPES.PHYSICAL,
    status: convertMemcardZyokyoToCardStatus(daikokuCard.memcard_zyokyo),
    password: daikokuCard.memcardpwd,
  }
}

const convertMemcardZyokyoToCardStatus = (
  zyokyo: MEMCARD_ZYOKYO
): CardStatus => {
  switch (zyokyo) {
    case MEMCARD_ZYOKYOS.IN_USE:
      return CARD_STATUSES.IN_USE
    case MEMCARD_ZYOKYOS.EXPIRED:
      return CARD_STATUSES.SUSPENDED
    case MEMCARD_ZYOKYOS.RESUMED:
      return CARD_STATUSES.IN_USE
    case MEMCARD_ZYOKYOS.SUSPENDED:
      return CARD_STATUSES.SUSPENDED
    case MEMCARD_ZYOKYOS.REMOVED:
      return CARD_STATUSES.SUSPENDED
    default:
      return CARD_STATUSES.SUSPENDED
  }
}
